import script from "./tableTitlePopover.vue?vue&type=script&setup=true&lang=js"
export * from "./tableTitlePopover.vue?vue&type=script&setup=true&lang=js"

import "./tableTitlePopover.vue?vue&type=style&index=0&id=54a7fefa&lang=less"

const __exports__ = script;

export default __exports__